import React, { useEffect, useState } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { useSelector } from "react-redux";

const PushMarketingStepper = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([false, false, false]);
  const message = useSelector(state => state.pushBatching.message);
  const emailList = useSelector(state => state.pushBatching.emailList);
  const completed = useSelector(state => state.pushBatching.completed);
  useEffect(() => {
    if (message) {
      setCurrentStep(1);
      setCompletedSteps([true, false, false]);
    }
    if (message && emailList) {
      setCurrentStep(2);
      setCompletedSteps([true, true, false]);
    }
    if (message && emailList && completed) {
      setCurrentStep(3);
      setCompletedSteps([true, true, true]);
    }
  }, []);
  return (
    <div className="mx-5 my-10">
      <Stepper
        activeStep={currentStep}
        style={{ backgroundColor: "transparent" }}
        alternativeLabel
      >
        <Step completed={completedSteps[0]}>
          <StepLabel>
            <p className={`text-${completedSteps[0] ? "black" : "gray"}}-500`}>
              Create batch message
            </p>
          </StepLabel>
        </Step>
        <Step completed={completedSteps[1]}>
          <StepLabel>
            <p className={`text-${completedSteps[0] ? "black" : "gray"}}-500`}>
              Upload cvs
            </p>
          </StepLabel>
        </Step>
        <Step completed={completedSteps[2]}>
          <StepLabel>
            <p className={`text-${completedSteps[0] ? "black" : "gray"}}-500`}>
              Review and submit
            </p>
          </StepLabel>
        </Step>
      </Stepper>
    </div>
  );
};

export default PushMarketingStepper;
